module.exports = __webpack_public_path__ + "static/img/president22.25f011a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/members/president22.jpg
// module id = czNn
// module chunks = 1